module.exports = __webpack_public_path__ + "assets/2ab105a54962eebfabfe365b9b39be0a.png";